// eslint-disable-next-line no-unused-vars
import Headroom from "headroom.js";
// eslint-disable-next-line no-unused-vars
import lity from "lity";
// eslint-disable-next-line no-unused-vars
import Sticky from "sticky-kit/dist/sticky-kit.js";

export default {
  init() {

    $(document).on(
      "click",
      "header .navbar-toggler",
      function (e) {
        e.preventDefault();
        e.stopPropagation();
        $("body").toggleClass("mm-menu-open");
        $("header #crw-nav-icon").toggleClass("open");
      }
    );

    // Language Switcher
    $(document).on("click", "header .cr-langsw-w .language-toggle", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const languageList = $(this);
      const isOpen = languageList.toggleClass("open").hasClass("open");

      if (isOpen) {
        $(document).on("click.closeLang", function (event) {
          if (!$(event.target).closest(".language-toggle, .cr-langsw-list").length) {
            languageList.removeClass("open");
            $(document).off("click.closeLang");
          }
        });
      }
    });

    var options = {
    // or you can specify offset individually for up/down scroll
      offset: 30,
    // scroll tolerance in px before state changes
      tolerance : {
        up: 0,
        down: 0,
      },
    // css classes to apply
    };

    // JavaScript to be fired on all pages
    const scroll_to_top = document.querySelector(".crw-header");
    if ( scroll_to_top ) {
      const headroom = new Headroom(scroll_to_top, options);
      headroom.init();
    }

    // Mobile sidebar navigation
    $(document).on("click", ".crw-sidebar .crw-sidebar-nav", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const nav = $(this);
      const navWidget = $(".crw-sidebar .crw-nav-widget");
      const isOpen = nav.toggleClass("open").hasClass("open");
      navWidget.toggleClass("open", isOpen);
    });


    // Smooth scroll to section
    $('.crw-nav-widget .nav-widget-list a[href^="#"]').on('click', function (e) {
      e.preventDefault();

      const $targetEle = $(this.hash);

      if ($targetEle.length) {
        $('html, body').stop().animate({
          scrollTop: $targetEle.offset().top - 148,
        }, 1000, 'swing');
      }
    });

    // Mobile Hero Section CTA nav
    $(document).on("click", ".crw-hero .hero-cnt-wrap .crw-hero-cta-nav", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const navWidget = $(".crw-hero .hero-cnt-wrap .hero-cta-menu");
      const isOpen = navWidget.toggleClass("open").hasClass("open");
      navWidget.toggleClass("open", isOpen);
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js